import React from "react";
import PropTypes from "prop-types";
import Header from "components/Admin/shared/Table/Header.jsx";

const titles = {
  start_date: "START DATE/TIME",
  webinar_title: "TITLE",
  speaker: "SPEAKERS",
  cpds: "CPD",
  cpd_points: "CPD POINTS",
  cpd_quiz: "CPD QUIZ",
  sponsor: "SPONSOR",
  status: "STATUS",
};

const miniLabel = {
  ext_cpd_points: "ext",
  int_cpd_points: "int",
};

const additionalProps = {
  start_date: {
    revert: true,
  },
  status: {
    thProps: {
      colSpan: "2",
    },
  },
  cpds: {
    values: ["ext_cpd_points", "int_cpd_points"],
    revert: true,
    miniLabels: miniLabel,
  },
};

function Headers({ onChange, value: selectedValue }) {
  return (
    <tr>
      <th></th>
      {Object.keys(titles).map((value) => (
        <Header
          onChange={onChange}
          key={value}
          values={[value]}
          title={titles[value]}
          selected={selectedValue}
          {...(additionalProps[value] || {})}
        />
      ))}
    </tr>
  );
}

Headers.defaultProps = {};

Headers.propTypes = {};

export default Headers;



// WEBPACK FOOTER //
// ./src/components/Admin/Webinar/List/Headers.jsx